const getLocalData = dataKey => {
  if (
    // eslint-disable-next-line
    __isBrowser__ &&
    typeof localStorage === "object" &&
    localStorage !== null
  ) {
    if (localStorage.getItem(dataKey)) {
      return JSON.parse(localStorage.getItem(dataKey));
    } else {
      return null;
    }
  } else {
    return null;
  }
};

export default getLocalData;
